import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";
import Element from "./Element";
import {AElement} from "../../../../models/elements/AElement";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    element: AElement
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 04/07/2022
 * @last_update 04/07/2022
 **/
class OldElement extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <Element
                element={this.props.element}
                label={getTranslation("steps.validation.labels.old-element")}
            />

        );

    };

}

export default withTranslation()(OldElement);
